import { useEffect, useState } from 'react';
import { UpdateFormEstimationMapper } from '@aviv-estimation-funnel/estimation-data-models/mappers/update-form-estimation-mapper';
import { Estimation } from '@aviv-estimation-funnel/estimation-data-models/models';
import { Box } from '@gemini/core';
import { getFormattedForm } from '@mfe-helpers/formHelpers';
import { TokenError } from '@mfe-presentation/constants/updatePage';
import { useAppContext, useAppDispatch } from '@mfe-presentation/contexts/appContext';
import useNavigation from '@mfe-presentation/hooks/useNavigation';
import useStepUtils from '@mfe-presentation/hooks/useStepUtils';
import Form from '@mfe-presentation/pages/Form';
import { getEstimationByToken } from '@mfe-services/getEstimationByToken';
import { EActionType } from '@mfe-types/context';
import { useSearchParams } from 'react-router-dom';
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { LoadingState } from '@gemini/ui';

const EstimationUpdate = () => {
    const dispatch = useAppDispatch();
    const { setStepAndNavigate } = useStepUtils();
    const [searchParams] = useSearchParams();
    const { handleNavigation } = useNavigation();
    const { stepNames, portal } = useAppContext();
    const [estimation, setEstimation] = useState<Estimation>();
    const estimationTokenJWT = searchParams.get('token');
    const isLegacy = searchParams.has('legacy');
    const { locale } = useLocale();

    useEffect(() => {
        setStepAndNavigate({ nextStepIndex: stepNames.indexOf('update') });
    }, []);

    useEffect(() => {
        (async () => {
            try {
                if (!estimationTokenJWT) {
                    throw new Error('Missing token parameter');
                }
                const estimationByToken = await getEstimationByToken(estimationTokenJWT, portal);

                setEstimation(estimationByToken);

                const formValuesFromEstimation =
                    UpdateFormEstimationMapper.fromEstimation(
                        estimationByToken,
                    ).newEstimationRequest;

                dispatch({
                    type: EActionType.SetStepValues,
                    payload: getFormattedForm(formValuesFromEstimation, locale),
                });

                dispatch({
                    type: EActionType.SetIsFromUpdatePage,
                    payload: true,
                });
                if (isLegacy) {
                    handleNavigation('first');
                }
            } catch (e: any) {
                dispatch({
                    type: EActionType.SetToastMessage,
                    payload: { status: TokenError.UpdatePageTokenError },
                });
                handleNavigation('first');
            }
        })();
    }, [estimationTokenJWT]);

    if (!estimation?.id) {
        return <LoadingState marginTop="spacing.40" />;
    }
    return (
        <Box as="section">
            <Form />
        </Box>
    );
};

export default EstimationUpdate;
